// extracted by mini-css-extract-plugin
export default {"monthly1":"ContentBody_monthly1__-jhdi","daily":"ContentBody_daily__XG1fY"};